import React from 'react';
import { Container, Row } from 'reactstrap';
import TabsBorderedTop from './components/TabsBorderedTop';

const ClinicHistoryView = (props) => {
 return (<Container className="dashboard">
          <Row>
              <TabsBorderedTop data={props.location.state.data} pageIndex={props.location.state.pageIndex}/>
          </Row>
        </Container>)
};

export default ClinicHistoryView;